import { createStore } from 'jotai';

/**
 * 全局 Jotai store
 * 用于在应用启动时初始化各种 atoms
 */
export const store = createStore();
